@if (viewModel(); as viewModel) {
  @if (isLoading()) {
    <mat-progress-spinner class="violation-rules-spinner" color="primary" mode="indeterminate"></mat-progress-spinner>
  } @else {
    <span class="violation-rules-header">
      <span class="violation-rules-header__group-by">
        <span>{{ 'policyPage.policy.violationRules.groupBy' | labelsProvider }}:</span>
        <div class="violation-rules-header-buttons">
          @for (button of sectionButtons; track button.section) {
            <button
              (click)="activeSection.set(button.section)"
              class="toggle-button"
              [ngClass]="{ disable: activeSection() !== button.section }"
            >
              {{ button.label | labelsProvider }}
            </button>
          }
        </div>
      </span>

      @if (
        isPoliciesRulesExportCsvButtonFeatureEnabled() && accessService.renderExportCSVButton(accountCategory$ | async)
      ) {
        <app-policy-export
          [integrationId]="integrationId()"
          [policyId]="policyId() ?? ''"
          [violationsDataType]="ruleType() === RuleTypeEnum.hygiene ? RuleTypeEnum.hygiene : RuleTypeEnum.risk"
          class="export-button-container"
        />
      }
    </span>

    <section class="violation-rules__tables-container">
      <app-violation-rules-filters
        [pageFilters]="pageFilters"
        [(isFiltersMenuOpen)]="isFilterMenuOpened"
        (optionOnSelection)="onFilterSelection()"
        class="violation-rules__filters"
      />

      <div class="violation-rules-tables">
        @for (group of viewModel.ruleGroups; track group.value) {
          <app-violation-rules-table
            [isLoading]="isLoading()"
            [currentRulesViewModel]="viewModel.rulesTables[group.value]"
            [categoryDisplayName]="group.displayName"
            [categoryCode]="group.value"
            [categoryLink]="group.link"
            (rowActionOnClick)="actionOnClick($event)"
          />
        } @empty {
          <app-coming-soon></app-coming-soon>
        }
      </div>
    </section>
  }
}
